import React from 'react';
import { MetodeContainer, MetodeCard, MetodeWrapper, MetodeIcon, MetodeH1, MetodeH2, MetodeP} from './Style';
import Icon1 from '../../assets/oleh.png';
import Icon2 from '../../assets/Pembayaran.png';
import Icon3 from '../../assets/Terima.png';

const Metode = ({refMetod}) => {
    return (
        <main ref={refMetod}>
        <MetodeContainer>
            <MetodeH1>Cara Pembelian</MetodeH1>
            <MetodeWrapper>
                <MetodeCard>
                    <MetodeIcon src={Icon1}/>
                    <MetodeH2>Pencarian Produk</MetodeH2>
                    <MetodeP>User dapat memilih jenis oleh-oleh yang tersedia didalam website kami yang ingin dibeli, 
                    klik icon keranjang untuk menambahkan produk yang ingin dibeli.</MetodeP>
                </MetodeCard>
                <MetodeCard>
                    <MetodeIcon src={Icon2}/>
                    <MetodeH2>Pembayaran</MetodeH2>
                    <MetodeP>Melakukan pembayaran dengan mengklik icon keranjang user pada navbar, 
                    setelah itu lanjutkan dan isi data pengiriman dan lakukan pembayaran dengan kartu kredit.</MetodeP>
                </MetodeCard>
                <MetodeCard>
                    <MetodeIcon src={Icon3}/>
                    <MetodeH2>Terima Produk</MetodeH2>
                    <MetodeP> Setelah user melakukan pembayaran, 
                    maka user akan menerima email verifikasi bahwa pembayaran sudah sukses, 
                    setelah itu paket akan dikirim ke alamat yang dimasukan.</MetodeP>
                </MetodeCard>
            </MetodeWrapper>
        </MetodeContainer>
        </main>
    )
}

export default Metode